import { formatDate } from '@btime/helpers'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { UserAvatar } from '../../components/presentation/Avatar'
import { useOpenUserModal } from '../../utils/routes/modals/modalsActions'
import { useUserFastActionsList } from '../../utils/actions/users/fastList'
import Card, { CardHeader } from '../../packages/kiti/components/presentation/Card'
import IconText from '../../packages/kiti/components/presentation/IconText'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../packages/kiti/components/presentation/Text'

const UserCard = ({ item }) => {
  const openModal = useOpenUserModal()
  const actions = useUserFastActionsList(item)

  return (
    <Card item={item} onClick={() => openModal({ id: item.id })} actions={actions}>
      <CardHeader />

      <Grid gap={0.4} align="center">
        <UserAvatar user={item} size="small" />
        <Title size="h6" bold color="dark1" noMargin>
          {item.name}
        </Title>
      </Grid>
      <Separator weight={4} />
      <IconText iconLeft="BsBuilding" label={item.contract?.profile?.label} color="dark2" />
      <Separator weight={2} />
      <IconText iconLeft="BsEnvelope" label={item.email} color="dark2" />
    </Card>
  )
}

export default UserCard
